import { render, staticRenderFns } from "./skeleton-row.vue?vue&type=template&id=2deb289d&"
import script from "./skeleton-row.vue?vue&type=script&lang=js&"
export * from "./skeleton-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports